import useMediaQuery from '@mui/material/useMediaQuery';
import { useSelector } from 'react-redux';

/**
 * Centralized hook to determine if Desktop View should be active.
 *
 * Rules:
 * 1. If FSR (Table Management) is active (sessionReducer.is_fsr === true),
 *    it ALWAYS returns false (FSR is strictly mobile view).
 * 2. Otherwise, returns true if screen width matches the desktop media query (default min-width: 900px).
 */
export const useIsDesktop = (query = '(min-width: 900px)') => {
  const isDesktopMedia = useMediaQuery(query);
  const isFSR = useSelector((state) => state.sessionReducer?.is_fsr === true);
  return isDesktopMedia && !isFSR;
};

export default useIsDesktop;
